import "@bgov/polyfills"

import { segmentWriteKey } from "./env"
import { createProvider } from '@/vue-apollo'

import Vue from "vue"
import VueRouter from "vue-router"
Vue.use(VueRouter)

import App from "./App.vue"
import router from "./router"
import { ErrorRendererPlugin, StandaloneJsPlugin } from "@bgov/vue-layouts"

let userApiHost: string | undefined

if (process.env.NODE_ENV !== "production") {
  userApiHost = "https://beta.bgov.com/"
}

import { AuthPlugin } from "@bgov/auth-plugin-vue"
Vue.use(AuthPlugin, { router, apiBaseUrl: userApiHost })

import AnalyticsPlugin from "@bgov/analytics-plugin-vue"
Vue.use(AnalyticsPlugin, { router, writeKey: segmentWriteKey })

Vue.use(ErrorRendererPlugin)

import bugsnagVue from "@bugsnag/plugin-vue"
import { bugsnagClient, setupAuthHandler } from "./bugsnag"

let myBgovApiHost: string =
  window.location.host !== "www.bgov.com" ? "beta.bgov.com" : "www.bgov.com"
Vue.use(StandaloneJsPlugin, {
  appName: "myBgov",
  apiPath: `https://${myBgovApiHost}/navigation_api/v1/my_bgov_app`,
})

setupAuthHandler(Vue.prototype.$auth)
bugsnagClient.use(bugsnagVue, Vue)

Vue.config.productionTip = false

new Vue({
  router: router,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount("#app")
;(window as any).sendTestError = (errString: string = "Test Error") => {
  bugsnagClient.notify(new Error(errString))
}
